import { AddressWithGeolocation, DeepPartial, Offer, OfferSavings, ProductTypes, Residence } from '~src/model';
import { deepNullToUndefined } from '~src/util';

import { useCalculateOfferSavings } from './graphql/useOffer';
import { CUSTOMER_ADDRESS, useCachedState } from './useCachedState';

export const useOfferSavings = (
  offer?: DeepPartial<Offer>,
  residence?: DeepPartial<Residence>,
  selectedProductTypes: ProductTypes = ['heatPump', 'solar']
): OfferSavings | undefined => {
  const [address] = useCachedState<AddressWithGeolocation>(CUSTOMER_ADDRESS);

  const result = useCalculateOfferSavings(
    {
      address: address ?? {},
      residence: residence ?? {},
      offer: offer ?? {},
      chosenHeating: offer?.chosenHeating,
      consumptionProfile: (residence?.consumption?.profileValue as number[]) ?? undefined,
    },
    selectedProductTypes
  );

  return deepNullToUndefined(result.data?.offerSavings);
};
